import React, { useEffect, useState } from 'react'
import { FaRegBell } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { useCookies } from 'react-cookie'
import axios from 'axios'
import key from '../../key'
// import { notification } from "antd"

function Notifications() {
    //eslint-disable-next-line
    const [cookies, setCookie, removeCookie] = useCookies(['x-auth-token']);
    const [notifications, setNotifications] = useState()
    useEffect(() => {
        const getNotifications = async () => {
            try {
                const res = await axios.get(`${key}/api/user/get-notifications`, {
                    headers: {
                        'x-auth-token': cookies['x-auth-token']
                    }
                })
                setNotifications(res.data.notifications?.slice(0, 5))
            } catch (err) {
                console.log(err)
            }
        }
        getNotifications()
        //eslint-disable-next-line
    }, [notifications])
    // const handelAll = async () => {
    //     try {
    //         const res = await axios.get(`${key}/api/user/get-notifications`, {
    //             headers: {
    //                 'x-auth-token': cookies['x-auth-token']
    //             }
    //         })
    //         console.log(res.data.notifications)
    //         setNotifications(res.data.notifications)
    //         notification.success({
    //             message: 'You Catched All the Notifications'})
    //     } catch (err) {
    //         console.log(err)
    //     }
    // }
    return (
        <div>
            <h6 className='text-secondary'><FaRegBell /> Notifications 
            {/* <span className='badge rounded-pill text-bg-danger fw-bold'>{20}</span> */}
             </h6>
            <div className='notification-container shadow-sm'>
                <ul>
                    {notifications?.map((notification, index) => {
                        return (
                            <li key={index} className='notification-item'>
                                <Link to={`/${notification?.notification?.url}`}>
                                    <div className='d-flex'>
                                        <div>
                                            <img className="notification-img" src={`${key}/images/${notification?.user?.photos[0].url}`} alt="notification" />
                                        </div>
                                        <div>
                                            <div className='normal-text'>{notification?.user?.firstName} {notification?.user?.lastName}</div>
                                            <div className='normal-text'>{notification?.notification?.message}</div>
                                        </div>
                                    </div>
                                </Link>
                            </li>
                        )
                    })
                    }
                    {/* <Link to='' onClick={handelAll} className='bold-link '>
                        <li className='notification-item text-center'>View All</li>
                    </Link> */}

                </ul>
            </div>
        </div>
    )
}

export default Notifications